import React from "react";
import "./case.css"; // 先ほどのCSSをインポート

const caseStudies = [
  {
    title: "インテリア",
    image: "https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=400&q=80",
    description: "楽天立ち上げ\n売上：月商50万→月商400万",
  },
  {
    title: "トレーニング用品",
    image: "https://i.ibb.co/N6VRSdVg/dunbell.png",
    description: "商品企画案件\n10商品企画し全て月商100万以上",
  },
  {
    title: "スクールグッズ",
    image: "https://images.unsplash.com/photo-1503676382389-4809596d5290?auto=format&fit=crop&w=400&q=80",
    description: "楽天コンサル\n売上：月商4,000万→月商5,000万",
  },
  {
    title: "バレエ用品",
    image: "https://i.ibb.co/sp0jS1YL/ballet.png",
    description: "Amazon運用代行\n売上：月商300万→月商500万",
  },
  {
    title: "シャンプー",
    image: "https://images.unsplash.com/photo-1516574187841-cb9cc2ca948b?auto=format&fit=crop&w=400&q=80",
    description: "Amazon コンサル\n売上：月商200万→月商600万",
  },
  {
    title: "アクセサリー",
    image: "https://images.unsplash.com/photo-1512436991641-6745cdb1723f?auto=format&fit=crop&w=400&q=80",
    description: "Amazon、楽天、Yahoo運用（社員時代）\n売上：月商400万円程度",
  },
  {
    title: "食品",
    image: "https://images.unsplash.com/photo-1504674900247-0877df9cc836?auto=format&fit=crop&w=400&q=80",
    description: "Amazonコンサル\n売上：月商300万→600万",
  },
];

export default function CaseStudies() {
  const firstRow = caseStudies.slice(0, 4);
  const secondRow = caseStudies.slice(4, 7);

  return (
    <section id="case" className="case-section">
  

      <div className="case-body">
        {/* 見出し */}
        <div className="case-performance-row">
          <span className="case-performance-bar"></span>
          <div>
            <span className="case-performance-title">運用実績</span>
            <div className="case-performance-label">PERFORMANCE</div>
          </div>
        </div>
        <div className="case-description">
          月商4,000万円規模の中〜大手企業様から月商100万円未満の中小企業様まで幅広くサポートさせて頂いております。<br />
          （業界や売上規模によって運用戦略を変更する為、クライアント様のご状況に合わせたサポートが可能になっております）
        </div>
        {/* 1段目 */}
        <div className="case-grid">
          {firstRow.map((item, i) => (
            <div className="case-card" key={i}>
              <div className="case-card-imgbox">
                <img src={item.image} alt={item.title} />
              </div>
              <div className="case-card-content">
                <div className="case-card-title">{item.title}</div>
                <div className="case-card-desc">{item.description}</div>
              </div>
            </div>
          ))}
        </div>
        {/* 2段目 */}
        <div className="case-grid-second">
          {secondRow.map((item, i) => (
            <div className="case-card" key={i}>
              <div className="case-card-imgbox">
                <img src={item.image} alt={item.title} />
              </div>
              <div className="case-card-content">
                <div className="case-card-title">{item.title}</div>
                <div className="case-card-desc">{item.description}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}